import { createLocalizationProvider, GetCatalogTextsFunction, LanguagesConfig, LocalizationConfig } from "@tm/localization"
import { ajax } from "@tm/utils"
import { UserContext, UserModuleType } from "@tm/models"
import { getModuleFromUserContext } from "@tm/context-distribution"
import { AppConfig } from "../data/loadConfiguration"
import { createLocaleUrl } from "./utils"

export async function getLocalizationProvider(
    config: AppConfig,
    defaultLanguagesConfig: LanguagesConfig,
    defaultLocalizationConfig: LocalizationConfig,
    getCatalogTexts: GetCatalogTextsFunction,
    userContext?: UserContext
) {
    const [localizationConfig, languagesConfig] = modifyLocalizationConfigs(defaultLocalizationConfig, defaultLanguagesConfig, config, userContext)

    return createLocalizationProvider(
        localizationConfig,
        (locale: string) => ajax({ url: createLocaleUrl(locale) }),
        languagesConfig,
        "/datelocales",
        getCatalogTexts
    )
}

function modifyLocalizationConfigs(
    localizationConfig: LocalizationConfig,
    languagesConfig: LanguagesConfig,
    config: AppConfig,
    userContext?: UserContext
): [LocalizationConfig, LanguagesConfig] {
    localizationConfig.overwriteCurrencyFormatLocale = userContext ? getOverwriteCurrencyFormatLocale(userContext) : undefined

    const { languagesWhitelist = [], languagesBlacklist = [] } = config

    if (languagesWhitelist.length) {
        languagesConfig = Object.keys(languagesConfig)
            .filter((x) => languagesWhitelist.includes(x))
            .reduce((prev, key) => ({ ...prev, [key]: languagesConfig[key] }), {})
    } else if (languagesBlacklist.length) {
        languagesConfig = Object.keys(languagesConfig)
            .filter((x) => !languagesBlacklist.includes(x))
            .reduce((prev, key) => ({ ...prev, [key]: languagesConfig[key] }), {})
    }

    return [localizationConfig, languagesConfig]
}

function getOverwriteCurrencyFormatLocale(userContext: UserContext): string | undefined {
    return getModuleFromUserContext(userContext, UserModuleType.Catalog)?.overwriteCurrencyFormatLocale
}
